
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, AlertCircle } from 'lucide-react';

const AuthCallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        console.log('Processando callback de autenticação...');
        
        // Processar o callback da URL
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Erro no callback:', error);
          setTimeout(() => navigate('/login?error=callback_failed'), 3000);
          return;
        }

        if (data.session) {
          console.log('Email confirmado com sucesso!', data.session.user.email);
          
          // Garantir que o perfil existe e está sincronizado
          try {
            const { error: profileError } = await supabase.rpc('ensure_profile_exists', {
              _user_id: data.session.user.id,
              _email: data.session.user.email || '',
              _first_name: data.session.user.user_metadata?.firstName || '',
              _phone: data.session.user.user_metadata?.phone || '',
              _whatsapp: data.session.user.user_metadata?.whatsapp || ''
            });

            if (profileError) {
              console.error('Erro ao sincronizar perfil:', profileError);
            }
          } catch (syncError) {
            console.error('Erro na sincronização:', syncError);
          }

          // Fallback: registrar lead de afiliado após confirmação (idempotente)
          try {
            const savedCode = localStorage.getItem('affiliateCode');
            if (savedCode) {
              console.log('Callback: registrando lead de afiliado (fallback):', savedCode);
              const { data: leadData, error: leadError } = await supabase.rpc('record_affiliate_lead', {
                p_affiliate_code: savedCode,
                p_customer_user_id: data.session.user.id
              });
              if (leadError) {
                console.error('Erro ao registrar lead no callback:', leadError);
              } else {
                console.log('Resultado record_affiliate_lead no callback:', leadData);
              }
            }
          } catch (leadErr) {
            console.error('Exceção no fallback de lead:', leadErr);
          }
          
          setTimeout(() => window.location.href = 'https://wa.me/5573981988263?text=Ol%C3%A1!%20Acabei%20de%20confirmar%20meu%20cadastro%20no%20IA%20Palpite%20Guru.%20Quero%20ativar%20meu%20plano%20e%20receber%20a%20oferta%20exclusiva%20para%20novos%20usu%C3%A1rios.%20Pode%20me%20ajudar%20agora%3F', 2000);
        } else {
          console.log('Nenhuma sessão encontrada no callback');
          setTimeout(() => navigate('/login'), 3000);
        }
      } catch (error) {
        console.error('Erro geral no callback:', error);
        setTimeout(() => navigate('/login?error=unexpected'), 3000);
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4 py-6">
      <Card className="w-full max-w-md mx-auto shadow-xl">
        <CardHeader className="text-center pb-6">
          <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6 animate-pulse">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          <CardTitle className="text-2xl md:text-3xl font-bold text-green-700 mb-2">
            Email Confirmado!
          </CardTitle>
        </CardHeader>
        
        <CardContent className="text-center space-y-4">
          <p className="text-lg text-gray-600">
            Seu email foi confirmado com sucesso.
          </p>
          <p className="text-sm text-gray-500">
            Redirecionando você para o WhatsApp em alguns segundos...
          </p>
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
          </div>
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full mt-4 inline-flex items-center justify-center rounded-md bg-blue-600 hover:bg-blue-700 text-white font-semibold h-11 px-4 transition-colors"
          >
            Entrar na plataforma agora →
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthCallbackPage;
